import React, { useState } from 'react';
import { Grid, Box, Card, CardContent, Typography, TextField, Button } from '@mui/material';
import axiosInstance from '../services/axiosInstance';
import { useParams, useNavigate } from 'react-router-dom';

const RegisterPage = () => {
    const { client } = useParams();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!email) {
            setError('Email is required.');
            return;
        }

        setError('');
        setSuccess('');

        try {
            const token = localStorage.getItem('token');

            await axiosInstance.post(`/userinfo/register`, {
                email
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setSuccess('Registration successful!');
            setEmail('');
            navigate('/registeredUsers/' + client);
        } catch (err) {
            console.error('Error during registration:', err);
            setError('Registration failed. Please try again.');
        }
    };

    return (
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={3}>
            <Grid item xs={12} md={6}>
                <Box sx={{ minHeight: 150 }} />
                <Card sx={{ borderRadius: '25px' }}>
                    <CardContent>
                        <Typography variant="h4" gutterBottom>Register New User</Typography>
                        {error && <Typography color="error">{error}</Typography>}
                        {success && <Typography color="primary">{success}</Typography>}
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Email"
                                        fullWidth
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="email"
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button type="submit" variant="contained" color="primary" fullWidth>
                                        Register
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default RegisterPage;
